
//event for pricing re-loading when Vue load content that include price eleemnts
//@todo find better alternative for Vue events.
window.addEventListener('eshopworld-loaded', function(e) {
  //method trigger prices update for example in case when prices elements been loaded via ajax
    if (window.eshopworld.methods && Object.keys(window.eshopworld.methods).length > 0) {
      window.eshopworld.methods.updatePrices();
      window.eshopLoaded = true;
    }
});


document.addEventListener('DOMContentLoaded', function() {
  	window.addEventListener('eshopworld-loaded', function(e) {
      //get current country

      // VPV Custom Solution for failed to load eshop world https://app.asana.com/0/1201439649988666/1201433176575253/f
      if (window.eshopworld.methods && Object.keys(window.eshopworld.methods).length === 0) {
        console.error('Eshop World Script Failed')
        window.eshopLoaded = false;
        const $preRender = document.querySelector('.eshopworld-cart-anchor.pre-render')
        if ($preRender) $preRender.classList.remove('pre-render')
      }


      const countryCode = window.eshopworld?.shopify?.currency?.shopperCountry || 'US'
      const currencyCode = window.eshopworld?.shopify?.currency?.code || 'USD';
      // eshopworldCartAdjust(countryCode)
      // window.eshopCountryCode = countryCode;
      // window.dispatchEvent(new Event('eshopworld-country-selected'))
      eshopGlobalHide(countryCode)
      eshopworldLandingMat(countryCode, currencyCode);

      window.dispatchEvent(new Event('eshopworld-updated'))
      window.eshopUpdated = true
    });
  window.addEventListener('eshopworld-widget-landing-mat-loaded', function(e) {
  	const countryCode = window.eshopworld?.shopify?.currency?.shopperCountry || 'US';

    if (countryCode == 'US') {
    	const landingMat = document.querySelector('.eshopworld-landing-mat');

        if (landingMat) {
        	landingMat.style.display = 'none';
        }
    }
  });
     window.addEventListener('eshopworld-on-country-select', function(e) {
      //get current country
      const countryCode = e.detail.countryCode
      window.eshopCountryCode = countryCode;
      eshopGlobalHide(countryCode)
      // eshopworldCartAdjust(countryCode)
      document.documentElement.dataset.currencyCode = e.detail.currencyCode

      window.dispatchEvent(new Event('eshopworld-country-selected'))
    });
});

function eshopGlobalHide(countryCode) {
  window.eshopCountryCode = countryCode;
  const matCookie = '_esw_country_code';
  setCookie(matCookie, countryCode, 24);
}

function eshopworldLandingMat(countryCode, currencyCode) {
  const matCookie = '_esw_mat_submitted';
  if (countryCode == 'US') {
   	const isSubmitted = getCookie(matCookie);

    if (!isSubmitted) {
      setCookie(matCookie, true, 24);
    }
  }
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function eshopworldCartAdjust(countryCode) {
  //based on rules hide Vue minicart or ESW
  const nativeCart = document.querySelector('.global-cart__drawer__item-list');
  const eswCart = document.querySelector('div.eshopworld-minicart-anchor');
  const nativeCartFooter = document.querySelector('.global-cart__drawer__footer');
  //native country check, for native we display native mini cart
  if (countryCode == 'US') {
    nativeCart.style.display = 'block';
    nativeCartFooter.style.display = 'block';
    eswCart.style.display = 'none';
  } else if (countryCode != 'US') {
    //for non native country we display ESW mini cart widget
    nativeCart.style.display = 'none';
    nativeCartFooter.style.display = 'none';
    eswCart.style.display = 'block';
  }
}